import Editor from "~/js/editor";
import { axiosClient } from "~/js/network/axiosClient";
import EventAnalytics from "~/js/utilities/EventAnalytics";
import * as network from "./network-handler";

const API_SCOPE = "api/v2/tasks/";
const SET_TASK_STATUS_URL = `${API_SCOPE}task_status_list`;
const TaskStatus = {
	New: "new",
	Preparing: "preparing",
	Pending: "pending",
	Running: "running",
	WaitingForLaunc: "waiting_for_launch",
	Done: "done",
	Error: "error",
	Canceled: "canceled",
	Error_exec_timeout: "error_exec_timeout",
	Error_cuda: "error_cuda",
	Error_params: "error_params"
};
Object.freeze(TaskStatus);
const LimitStatus = "tariff_task_execution_limit";

/**
 * Create node execution task on server and returns this new task ID
 * @return {Promise<number>} new task ID
 */
const createTaskAsync = async (nodeData, signal) => {
	try {
		console.log("Creating task... NodeData: ", nodeData);
		const url = network.config.SERVER_HOST + API_SCOPE;
		console.log(`POST-request url ${url}`);

		const response = await axiosClient.axiosClient.post(url, nodeData, {
			headers: network.standardHeaders(),
			signal
		});
		console.log("Response", response);
		if (response.status > 399) {
			throw `Request Error ${response.status} ${response.statusText}`;
		}

		const responseJson = response.data;
		console.log("Response Json", responseJson);

		if (responseJson.task_id === undefined) {
			console.error("Failed to create task. Responded with undefined task_id.");
			throw "Something went wrong while task creating on the server";
		}

		console.log(`Task has been created successful! Task ID = ${responseJson.task_id}`);

		Editor.context.graph.revalidateDisability();

		return responseJson;
	} catch (err) {
		if (err?.code === "ERR_CANCELED") return;
		if (err.response.status === 400 && err.response.data?.detail.code === LimitStatus) {
			Editor.context.graph.revalidateDisability();
			throw "limit exceeded";
		}
		EventAnalytics.sendErrorInfo("error-task-creating", {
			message: err?.toString?.() || err.message,
			...(err.response ? { statusCode: err.response.status } : {})
		});
		console.error(`Task creating error: "${err}"`);
		throw "Something went wrong while task creating on the server";
	}
};

/**
 * Set tasks status to canceled and returns null as success
 * @return {Promise<null>}
 */
const stopTasksAsync = async (nodesData, forced) => {
	const nodesToCancel = [];
	for (const nodeData of nodesData) {
		if (nodeData.taskID > 0) {
			nodesToCancel.push({
				task_id: nodeData.taskID,
				status: TaskStatus.Canceled
			});
		}
	}
	if (nodesToCancel.length > 0) {
		try {
			console.log("Canceling tasks with IDs: ", nodesToCancel);
			const url = SET_TASK_STATUS_URL;
			console.log(`POST-request url ${url}`);

			const response = await axiosClient.axiosClient.post(url, nodesToCancel, {
				headers: network.jsonHeaders(),
				params: {
					...(forced ? { forced } : {})
				}
			});
			console.log("Response", response);
			if (response.status > 399) {
				throw `Request Error ${response.status} ${response.statusText}`;
			}

			const responseJson = response.data;
			console.log("Response Json", responseJson);

			if (response.status !== 200) {
				console.error("Failed to cancel tasks");
				throw "Something went wrong while tasks canceling on the server";
			}

			console.log(`Tasks has been successfuly canceled! Task IDs = ${nodesToCancel}`);
		} catch (err) {
			EventAnalytics.sendErrorInfo("error-task-canceling", {
				message: err.message,
				...(err.response ? { statusCode: err.response.status } : {})
			});
			console.error(`Task cancel error: "${err}"`);
			throw "Something went wrong while task canceling on the server";
		}
	} else {
		console.log("There are no tasks to cancel: ", nodesData);
	}
};

const NodeExecutionTask = {
	createTaskAsync,
	stopTasksAsync
};
export default NodeExecutionTask;
